webpackJsonp([8],{

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(912)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(885),
  /* template */
  __webpack_require__(950),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03c90b56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isloading: false,
      wrapperClick: true
    };
  },

  methods: {
    navigateToCentralAnalytics: function navigateToCentralAnalytics() {
      var _this = this;

      this.isLoading = true;
      setTimeout(function () {
        _this.$router.push("central_analytics");
      }, 1000);
    },
    wrapperClicked: function wrapperClicked() {
      this.wrapperClick = !this.wrapperClick;
    }
  }
});

/***/ }),

/***/ 891:
/***/ (function(module, exports) {

throw new Error("Module build failed: Error: Node Sass does not yet support your current environment: Linux 64-bit with Unsupported runtime (83)\nFor more information on which environments are supported please see:\nhttps://github.com/sass/node-sass/releases/tag/v4.9.2\n    at module.exports (/var/www/msdat-dashboard/node_modules/node-sass/lib/binding.js:13:13)\n    at Object.<anonymous> (/var/www/msdat-dashboard/node_modules/node-sass/lib/index.js:14:35)\n    at Module._compile (internal/modules/cjs/loader.js:1085:14)\n    at Object.Module._extensions..js (internal/modules/cjs/loader.js:1114:10)\n    at Module.load (internal/modules/cjs/loader.js:950:32)\n    at Function.Module._load (internal/modules/cjs/loader.js:790:12)\n    at Module.require (internal/modules/cjs/loader.js:974:19)\n    at require (internal/modules/cjs/helpers.js:101:18)\n    at Object.<anonymous> (/var/www/msdat-dashboard/node_modules/sass-loader/lib/loader.js:3:14)\n    at Module._compile (internal/modules/cjs/loader.js:1085:14)\n    at Object.Module._extensions..js (internal/modules/cjs/loader.js:1114:10)\n    at Module.load (internal/modules/cjs/loader.js:950:32)\n    at Function.Module._load (internal/modules/cjs/loader.js:790:12)\n    at Module.require (internal/modules/cjs/loader.js:974:19)\n    at require (internal/modules/cjs/helpers.js:101:18)\n    at loadLoader (/var/www/msdat-dashboard/node_modules/loader-runner/lib/loadLoader.js:13:17)");

/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(891);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("123b0b96", content, true, {});

/***/ }),

/***/ 950:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "id": "loading-screen"
    }
  }, [_c('div', {
    staticClass: "fancy-loader"
  }, [_c('span', [_vm._v("LOADING")]), _vm._v(" "), _c('svg', {
    staticClass: "lds-comets",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "250px",
      "height": "250px",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid"
    }
  }, [_c('g', {
    attrs: {
      "transform": "rotate(162.228 50 50)"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "repeatCount": "indefinite",
      "values": "360 50 50;240 50 50;120 50 50;0 50 50",
      "keyTimes": "0;0.333;0.667;1",
      "dur": "1s",
      "keySplines": "0.7 0 0.3 1;0.7 0 0.3 1;0.7 0 0.3 1",
      "calcMode": "spline"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#41918E",
      "d": "M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E0E0E0",
      "d": "M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#80CBC4",
      "d": "M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-md-12"
  }, [_c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right",
      value: ('Back to platform'),
      expression: "'Back to platform'",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "back-to-car-icon",
    on: {
      "click": _vm.navigateToCentralAnalytics
    }
  }, [_c('v-icon', {
    staticClass: "back-to-car-icon-v",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("arrow_back")])], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "item",
    class: {
      'list_short': _vm.wrapperClick
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 col-xs-offset-4",
    staticStyle: {
      "padding-top": "25px",
      "padding-bottom": "80px",
      "color": "white"
    }
  }, [_c('button', {
    staticClass: "btn btn-more",
    on: {
      "click": _vm.wrapperClicked
    }
  }, [_vm._v("\n        " + _vm._s(_vm.wrapperClick ? "Show More" : "Show Less") + "\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('h1', {
    staticClass: "update_title",
    attrs: {
      "id": "top_of_page"
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('h5', {
    staticClass: "update_subtitle"
  }, [_vm._v("\n        The MSDAT platform is updated regularly to ensure optimum experience\n        and data quality.\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline",
    attrs: {
      "id": "timeline"
    }
  }, [_c('section', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticClass: "date"
  }, [_vm._v("October 30th, 2019")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('h3', {
    staticClass: "right__title"
  }, [_vm._v("Version 1.3 Updates (Performance Improvement)")]), _vm._v(" "), _c('h4', {
    staticClass: "right__subtitle"
  }, [_vm._v("Features")]), _vm._v(" "), _c('p', [_vm._v("The following features were introduced in version 1.3 of the MSDAT platform:")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_vm._v("Indicator Overview with related indicators")]), _vm._v(" "), _c('li', [_vm._v("Indicator Trend analysis across data sources")]), _vm._v(" "), _c('li', [_vm._v("Comparison of selected Indicator and related indicators across data sources (Routine, Surveys, Estimate)")]), _vm._v(" "), _c('li', [_vm._v("Indicator distribution by states and LGAs")]), _vm._v(" "), _c('li', [_vm._v("Indicator definitions and meta-data")]), _vm._v(" "), _c('li', [_vm._v("Geopolitical zonal analysis of Indicator")]), _vm._v(" "), _c('li', [_vm._v("Multi-Source Indicator Comparison")]), _vm._v(" "), _c('li', [_vm._v("Multi-Dataset Comparison of Indicator by states")]), _vm._v(" "), _c('li', [_vm._v("MSDAT Onboarding & Tour guide")]), _vm._v(" "), _c('li', [_vm._v("Data Download in multiple formats")]), _vm._v(" "), _c('li', [_vm._v("Share dashboard feature")]), _vm._v(" "), _c('li', [_vm._v("Mobile responsive view")]), _vm._v(" "), _c('li', [_vm._v("Feedback tool")]), _vm._v(" "), _c('li', [_vm._v("Offline web capabilities")]), _vm._v(" "), _c('li', [_vm._v("Submit data source feature")]), _vm._v(" "), _c('li', [_vm._v("Date Last Updated on dashboard footer ")]), _vm._v(" "), _c('li', [_vm._v("Automatic cache-clearing for browser after 30 days")]), _vm._v(" "), _c('li', [_vm._v("Automatic browser caches clearing if page doesn’t load after 30 seconds")]), _vm._v(" "), _c('li', [_vm._v("MSDAT Contact page ")]), _vm._v(" "), _c('li', [_vm._v("MSDAT About page with information on available data")]), _vm._v(" "), _c('li', [_vm._v("Contact form pop-up ")]), _vm._v(" "), _c('li', [_vm._v("Unsupported browser pop-up alert")]), _vm._v(" "), _c('li', [_vm._v("GZip compression enabled ")])]), _vm._v(" "), _c('h4', {
    staticClass: "right__subtitle"
  }, [_vm._v("Data Updates")]), _vm._v(" "), _c('p', [_vm._v("The following data updates were made in version 1.3 of the MSDAT platform:")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_vm._v("32 Indicators across 17 data sources and 6 program areas: RMNCH, Malaria, Immunization, Nutrition, Mortality & HIV")]), _vm._v(" "), _c('li', [_vm._v("National & SDG Targets added where applicable")]), _vm._v(" "), _c('li', [_vm._v("Confidence range values added where applicable")])])])])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.3fb7077058005df30d8a.js